import type { UserAction } from './user';
import { userReducer, userInitial } from './user';
import type { ConfigAction } from './config';
import { configReducer, configInitial } from './config';
import type { OnboardingState, OnboardingAction } from './reducers.types';
import type { AuthenticationAction } from './authentication';
import { authenticationInitial, authenticationReducer } from './authentication';

export const rootReducer = (
  { user, config, authentication }: OnboardingState,
  action: OnboardingAction
): OnboardingState => ({
  config: configReducer(config, action as ConfigAction),
  user: userReducer(user, action as UserAction),
  authentication: authenticationReducer(
    authentication,
    action as AuthenticationAction
  )
});

export const initialRoot = {
  user: userInitial,
  config: configInitial,
  authentication: authenticationInitial
};
